import { type Theme as MuiTheme, styled } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'

export const DATA_GRID_BORDER_WIDTH = 1

const getEnabledCellBackgroundColor = (theme: MuiTheme) =>
  theme.palette.mode === 'light' ? theme.palette.background.default : theme.palette.background.paper
const getHeaderCellBackgroundColor = (theme: MuiTheme) =>
  theme.palette.mode === 'light' ? theme.palette.background.paper : theme.palette.background.default

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
  borderWidth: DATA_GRID_BORDER_WIDTH,
  borderColor: theme.palette.mode === 'light' ? theme.palette.grey[300] : theme.palette.grey[900],
  WebkitFontSmoothing: 'auto',
  letterSpacing: 'normal',
  '& .MuiDataGrid-iconSeparator': {
    display: 'none'
  },
  '& .MuiDataGrid-columnHeader': {
    backgroundColor: getHeaderCellBackgroundColor(theme),
    '&:last-child': {
      borderRightWidth: 0
    }
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 'bold'
  },
  '& .MuiDataGrid-cell': {
    backgroundColor: getEnabledCellBackgroundColor(theme),
    '&--disabled': {
      backgroundColor: theme.palette.action.disabledBackground
    },
    '&--editing': {
      backgroundColor: `${getEnabledCellBackgroundColor(theme)} !important`
    }
  },
  '& .MuiPaginationItem-root': {
    borderRadius: 0
  },
  '.MuiDataGrid-row': {
    '& .MuiDataGrid-cell': {
      // Account for the first child which is MuiDataGrid-cellOffsetLeft
      '&:nth-of-type(2)': {
        backgroundColor: getHeaderCellBackgroundColor(theme),
        fontWeight: 'bold'
      },
      '&:last-child': {
        borderRightWidth: 0
      },
      '&.IsEdited': {
        backgroundColor: theme.palette.focus.main
      },
      '&.IsUpdated': {
        backgroundColor: theme.palette.successSelected.main
      }
    },
    '&:hover': {
      backgroundColor: 'inherit'
    },
    '&.MuiDataGrid-row--lastVisible': {
      '& .MuiDataGrid-cell': {
        borderBottomWidth: 0
      }
    }
  }
}))

export default StyledDataGrid
